// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3SP39","colBig":"styles_colBig__3YuJA","colSmall":"styles_colSmall__27-YS"};